import { Injectable, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LoginResponse, User } from '../models/user.model';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  SUPPORT_LOGIN_KEY = 'support-login';
  ACCESS_TOKEN_KEY = 'access-token';
  PERMISSIONS_KEY = 'permissions';

  user = signal<User | null>(null)
  permissions = signal<string[]>([])

  constructor() {
    this.initUserData()
  }

  setLoginRespnse(loginRes: LoginResponse) {
    if (loginRes.token) localStorage.setItem(this.ACCESS_TOKEN_KEY, loginRes.token)
    if (loginRes.user) this.setUser(loginRes.user)
    if (loginRes.permissions) this.setPermissions(loginRes.permissions)
  }

  setUser(user: User) {
    localStorage.setItem(this.SUPPORT_LOGIN_KEY, JSON.stringify(user));
    this.user.set(user);
  }
  setPermissions(permissions: string[]) {
    localStorage.setItem(this.PERMISSIONS_KEY, JSON.stringify(permissions));
    this.permissions.set(permissions);
  }

  initUserData() {
    this.user.set(this.getUser());
    this.permissions.set(this.getPermissions());
  }

  getUser() {
    const sotredUser = localStorage.getItem(this.SUPPORT_LOGIN_KEY);
    const parsedUser = sotredUser ? JSON.parse(sotredUser) : null;
    return parsedUser;
  }
  getPermissions() {
    const sotredPermissions = localStorage.getItem(this.PERMISSIONS_KEY);
    const parsedPermissions = sotredPermissions ? JSON.parse(sotredPermissions) : [];
    return parsedPermissions;
  }

  getToken(): string | null {
    const storedLogin = localStorage.getItem(this.ACCESS_TOKEN_KEY);
    return storedLogin;
  }

  clearStorageonLogout() {
    localStorage.removeItem(this.SUPPORT_LOGIN_KEY);
    localStorage.removeItem(this.ACCESS_TOKEN_KEY);
    localStorage.removeItem(this.PERMISSIONS_KEY);
  }
}
